import styled from 'styled-components';

export type ModalSize = 'sm' | 'md' | 'lg';

const ModalBody = styled.div<{ size: ModalSize }>`
  max-height: ${(props) => (props.size === 'sm' ? '300px' : '440px')};
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;

  @media (max-height: 600px) {
    max-height: 250px;
  }
`;

const ModalContent = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;
const ModalDialogeStyled = {
  ModalBody,
  ModalContent,
};

export default ModalDialogeStyled;
